import { render, staticRenderFns } from "./Future.vue?vue&type=template&id=73451ecb&scoped=true&"
import script from "./Future.vue?vue&type=script&lang=ts&"
export * from "./Future.vue?vue&type=script&lang=ts&"
import style0 from "./Future.vue?vue&type=style&index=0&id=73451ecb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73451ecb",
  null
  
)

export default component.exports